import run from '../../utilities/run';
import $ from 'jquery';
import _ from 'underscore';
import render from "../../utilities/render";
import { setSwitchery, enableSwitchery, disableSwitchery } from '../../utilities/instantiateSwitchery';
import { getMap, getAdditionalCarrierMap } from '../orderType/elementsbindMap';
import { isNull, isNullOrUndefined } from 'util';
import { instantiateSelect2 } from "../../utilities/select2able";
import { handleDisplayFor, setElementsFromScope, hide, show, handleDisplayForV2, setDisabled, disableInput, enableInput } from "../../utilities/selectorHelpers";
import { createPreventDefault } from '../../utilities/general';

const elementsPageMap = getMap();
const additionalCarrierElementsMap = getAdditionalCarrierMap();
const elsPage = {};
const entryEl = $("<div class='entry-point'></div>");
const targetSelector = "#create-order-type-form";
const additionalCarrierHtml = require('./html/AdditonalCarriers.html');

export default function PackagingTab(wizard) {

    const self = this;
    const wizardEl = wizard.getWizardElement();
    const mainEl = $(".packaging-tab");
    const editFlag = mainEl.data("edit-flag");
    const isDup = wizardEl.data("dup-flag");
    let editOrderType = {};
    if (editFlag) {
        editOrderType = mainEl.data("edit-order-type-data");
    }



    init();

    self.didNavigateToForm = function() {
        return validatePackagingTab();
    };

    const boxTypeList = elsPage.orderTypeBoxType.data('options');
    const tissuePaperList = elsPage.orderTypeTissuePaper.data('options');
    const orderSlipList = elsPage.orderSlip.data('options');
    const packageSlipList = elsPage.packageSlip.data('options');
    const orderTypeCountryCodeList = elsPage.orderTypeCountryCode.data('options');
    const facilityAddressObj = elsPage.facilityAddress.data('options');
    const retailerAddress = facilityAddressObj.retailerAddress;
    const facilityAddressList = facilityAddressObj.facilitiesAddress;

    loadDropDowns();

    function validatePackagingTab() {
        let isValid = false;
        if (wizardEl.valid()) {
            isValid = true;
        }
        return isValid;
    }

    function init() {
        setElements();
        bindElements();
        elsPage.customDocPhoneNumber.inputmask({
            mask: "(999) 999-9999"
        });
    }

    function setElements() {
        setElementsFromScope(elsPage, elementsPageMap, wizardEl);
    };

    function bindElements() {
        if(elsPage.orderTypeRetailerSwitch.is(":checked") && !elsPage.orderTypeDropShipSwitch.is(":checked")){
            elsPage.includePackageDiv.show();
        } else{
            elsPage.includePackageDiv.hide();
        }

        elsPage.orderTypeBoxType.on("change", function(e) {
            $.each(boxTypeList, function(index, value) {
                const boxTypeVal = elsPage.orderTypeBoxType.val();
                if (boxTypeVal == this.cdmValue) {
                    elsPage.boxTypeDesc.text(this.cdmDescription);
                }
            });
        });

        elsPage.orderTypeTissuePaper.on("change", function(e) {
            $.each(tissuePaperList, function(index, value) {
                const tissuePaperVal = elsPage.orderTypeTissuePaper.val();
                if (tissuePaperVal == this.cdmValue) {
                    elsPage.tissuePaperDesc.text(this.cdmDescription);
                }
            });
        });


        elsPage.packagePackingSlip.on("change", function(e) {
            if (elsPage.packagePackingSlip.prop("checked") == true || elsPage.orderPackingSlip.prop("checked") == true) {
                $('.customize-section').show();
            } else {
                $('.customize-section').hide();
            }
        });

        elsPage.orderPackingSlip.on("change", function(e) {
            if (elsPage.packagePackingSlip.prop("checked") == true || elsPage.orderPackingSlip.prop("checked") == true) {
                $('.customize-section').show();
            } else {
                $('.customize-section').hide();
            }
        });

        elsPage.facilityAddress.on("change", function(e) {

            const selVal = elsPage.facilityAddress.val();
            const selTxt = $('.order-type-facility option:selected').text();
            let addressTxt1 = "";
            let addressTxt2 = "";

            if (selTxt == 'Main Location') {
                const retAddrss = retailerAddress[0];
                addressTxt1 = retAddrss.rtlAddress1 + ((retAddrss.rtlAddress2 == null) ? "" : (", " + retAddrss.rtlAddress2));
                addressTxt2 = retAddrss.rtlCity + ", " + retAddrss.rtlState + ", " + retAddrss.rtlZip;
            } else {

                $.each(facilityAddressList, function(index, value) {
                    if (selVal == this.cadLocationName) {
                        const cmrAddrss = this;
                        addressTxt1 = cmrAddrss.cadAddress1 + ((cmrAddrss.cadAddress2 == null) ? "" : (", " + cmrAddrss.cadAddress2));
                        addressTxt2 = cmrAddrss.cadCity + ", " + cmrAddrss.cadState + ", " + cmrAddrss.cadZipcode;
                    }

                });

            }

            elsPage.orderTypeFacilityAddrss1.text(addressTxt1);
            elsPage.orderTypeFacilityAddrss2.text(addressTxt2);


        });
    }

    function loadDropDowns() {         
            $.each(boxTypeList, function(index, value) {
                const option = $('<option />');
                option.attr('value', this.cdmValue).text(this.cdmValue);
                elsPage.orderTypeBoxType.append(option);
            });
            elsPage.boxTypeDesc.text(boxTypeList[0].cdmDescription);

            $.each(tissuePaperList, function(index, value) {
                const option = $('<option />');
                option.attr('value', this.cdmValue).text(this.cdmValue);
                if (this.cdmDescription == 'No Additional Charge') {
                    option.attr('selected', 'true');
                    elsPage.tissuePaperDesc.text(tissuePaperList[index].cdmDescription);
                }
                elsPage.orderTypeTissuePaper.append(option);
            });

            $.each(orderTypeCountryCodeList, function(index, value) {
                const option = $('<option />');
                option.attr('value', this.conPhoneCode).text(this.conName + ' ' + this.conPhoneCode);
                elsPage.orderTypeCountryCode.append(option);
            });

            $.each(orderSlipList, function(index, value) {
                const option = $('<option />');
                option.attr('value', this.cdmValue).text(this.cdmMeaning);
                elsPage.orderSlip.append(option);
            });

            $.each(packageSlipList, function(index, value) {
                const option = $('<option />');
                option.attr('value', this.cdmValue).text(this.cdmMeaning);
                elsPage.packageSlip.append(option);
            });

            const retAddrss = retailerAddress[0];
            const option = $('<option />');
            option.attr('value', retAddrss.rtlId).text("Main Location");
            elsPage.facilityAddress.append(option);

            $.each(facilityAddressList, function(index, value) {
                const option = $('<option />');
                option.attr('value', this.cadLocationName).text(this.cadLocationName);
                elsPage.facilityAddress.append(option);
            });

            let addressTxt1 = retAddrss.rtlAddress1 + ((retAddrss.rtlAddress2 == null) ? "" : (", " + retAddrss.rtlAddress2));
            let addressTxt2 = retAddrss.rtlCity + ", " + retAddrss.rtlState + ", " + retAddrss.rtlZip;

            elsPage.orderTypeFacilityAddrss1.text(addressTxt1);
            elsPage.orderTypeFacilityAddrss2.text(addressTxt2);
            if(editFlag) {
                  fillDropDownValues();
            }
        
    }

    function fillDropDownValues() {
        if (!isNullOrUndefined(editOrderType.retailerName) && isDup) {
            //Reset Fields To Default
        } else {
            elsPage.orderTypeBoxType.val(editOrderType.boxType);
            elsPage.boxTypeDesc.text(editOrderType.boxTypeDescription);
            elsPage.orderTypeTissuePaper.val(editOrderType.tissuePaper);
            elsPage.tissuePaperDesc.text(editOrderType.tissuePaperDesc);
        }
        if(!isNullOrUndefined(editOrderType.packingSlipCI.citemplate)){
            elsPage.orderSlip.val(editOrderType.packingSlipCI.citemplate);
        }
        if(!isNullOrUndefined(editOrderType.packingSlipCI.packingSlipTemplate)){
            elsPage.packageSlip.val(editOrderType.packingSlipCI.packingSlipTemplate);
        }
        if (!isNullOrUndefined(editOrderType.packingSlipCI.customizedDocument.facility)) {
            elsPage.facilityAddress.val(editOrderType.packingSlipCI.customizedDocument.facility.facilityName);
            let editAddressTxt1 = editOrderType.packingSlipCI.customizedDocument.facility.addressLine1 +
                ((editOrderType.packingSlipCI.customizedDocument.facility.addressLine2 == null) ? "" : (", " + editOrderType.packingSlipCI.customizedDocument.facility.addressLine2));
            let editAddressTxt2 = editOrderType.packingSlipCI.customizedDocument.facility.city + ", " + editOrderType.packingSlipCI.customizedDocument.facility.state + ", " + editOrderType.packingSlipCI.customizedDocument.facility.postalCode;
            elsPage.orderTypeFacilityAddrss1.text(editAddressTxt1);
            elsPage.orderTypeFacilityAddrss2.text(editAddressTxt2);
        }
        if (!isNullOrUndefined(editOrderType.packingSlipCI.customizedDocument.countryCode)) {
            elsPage.orderTypeCountryCode.val(editOrderType.packingSlipCI.customizedDocument.countryCode);
        }
   }
}


// WEBPACK FOOTER //
// ./src/pages/orderType/packagingTab.js